import React from 'react';
import { StatusBadge } from '../components';
import type { SafeDevice } from './types';

const value = (text?: string | null) => text || 'Unknown';
export function DeviceSummary({ device, compact = false }: { device: SafeDevice | null; compact?: boolean }) {
    if (!device) return <span className="device-empty">No active device</span>;
    return <div className={`device-summary ${compact ? 'device-summary--compact' : ''}`}>
        <div className="device-summary__title"><strong>{value(device.deviceName || device.model)}</strong><StatusBadge status={device.status} /></div>
        <span>{[device.manufacturer, device.model, device.platform].filter(Boolean).join(' · ') || 'Device metadata unavailable'}</span>
        {!compact && <><span>OS {value(device.osVersion)} · App {value(device.appVersion)}{device.appBuildNumber ? ` (${device.appBuildNumber})` : ''}</span><span>Last seen {device.lastSeenAt ? new Date(device.lastSeenAt).toLocaleString() : 'never'}</span></>}
        {device.fingerprintFragment && <code>Fingerprint {device.fingerprintFragment}</code>}
    </div>;
}
